/**
 * Lightweight English stemmer (suffix stripping, Porter-inspired).
 * Zero dependencies. Good enough for IR morphology normalization:
 *   tokens → token, running → runn, compressed → compress,
 *   authentication → authentic, handling → handl, subagents → subagent
 *
 * Not a full Porter stemmer — intentionally simpler and faster. CJK is
 * untouched (handled by bigram tokenization, not stemming).
 */
export function stem(word: string): string {
    let w = word;
    if (w.length <= 3) return w;
    if (w.endsWith("ies")) w = w.slice(0, -3) + "y";
    else if (w.endsWith("ses") || w.endsWith("xes") || w.endsWith("zes")) w = w.slice(0, -2);
    else if (w.endsWith("ches") || w.endsWith("shes")) w = w.slice(0, -2);
    else if (w.endsWith("s") && !w.endsWith("ss")) w = w.slice(0, -1);
    if (w.endsWith("ing") && w.length > 5) w = w.slice(0, -3);
    if (w.endsWith("ed") && w.length > 4) w = w.slice(0, -2);
    if (w.endsWith("ation") && w.length > 6) w = w.slice(0, -3);
    else if (w.endsWith("tion") && w.length > 5) w = w.slice(0, -4) + "t";
    else if (w.endsWith("ion") && w.length > 4) w = w.slice(0, -3);
    if (w.endsWith("ment") && w.length > 6) w = w.slice(0, -4);
    if (w.endsWith("ness") && w.length > 6) w = w.slice(0, -4);
    if (w.endsWith("ly") && w.length > 4) w = w.slice(0, -2);
    return w;
}
